var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"debounce",rawName:"v-debounce",value:(_vm.valueChanged),expression:"valueChanged"}],staticClass:"w-full form-control form-input form-input-bordered",attrs:{"type":"text","placeholder":_vm.$t('Enter number')},domProps:{"value":_vm.item.response}})])
}
var staticRenderFns = []

export { render, staticRenderFns }